import tiktokApi from '../../../../common/apis/tiktokApi';
import type { Clip } from '../../clipQueueSlice';
import type { ClipProvider } from '../providers';
import { createLogger } from '../../../../common/logging';

const logger = createLogger('TikTokProvider');

class TikTokProvider implements ClipProvider {
  name = 'tiktok';

  getIdFromUrl(url: string): string | undefined {
    try {
      console.log('[TikTokProvider] getIdFromUrl called with:', url);
      const uri = new URL(url);
      console.log('[TikTokProvider] Hostname:', uri.hostname, 'Pathname:', uri.pathname);

      if (uri.hostname.endsWith('tiktok.com')) {
        console.log('[TikTokProvider] Hostname matches TikTok pattern');
        const match = uri.pathname.match(/\/@[\w.-]+\/video\/(\d+)/);

        if (match) {
          console.log('[TikTokProvider] Extracted ID:', match[1]);
          return match[1];
        } else {
          console.log('[TikTokProvider] Path did not match video pattern');
        }
      } else {
        console.log('[TikTokProvider] Hostname did not match TikTok pattern');
      }
      return undefined;
    } catch (error) {
      console.error('[TikTokProvider] Error parsing URL:', error);
      return undefined;
    }
  }

  async getClipById(id: string): Promise<Clip | undefined> {
    if (!id) return undefined;

    logger.info('Fetching TikTok clip info for ID:', id);
    const clipInfo = await tiktokApi.getClip(id);

    if (!clipInfo) {
      logger.warn('No clip info returned from TikTok API for ID:', id);
      return undefined;
    }

    logger.info('TikTok clip info received:', clipInfo);

    const clip = {
      id,
      title: clipInfo.title || 'TikTok Video',
      author: clipInfo.author_name || 'TikTok User',
      url: this.getUrl(id),
      thumbnailUrl: clipInfo.thumbnail_url,
      submitters: [],
      Platform: 'TikTok' as const,
    };

    logger.info('Returning TikTok clip:', clip);
    return clip;
  }

  getUrl(id: string): string | undefined {
    return `https://www.tiktok.com/video/${id}`;
  }

  getEmbedUrl(id: string): string | undefined {
    return `https://www.tiktok.com/embed/v2/${id}`;
  }

  async getAutoplayUrl(id: string): Promise<string | undefined> {
    return undefined; // TikTok embeds don't reliably support autoplay
  }
}

const tiktokProvider = new TikTokProvider();
export default tiktokProvider;
